/**
 * NavBtn — generic nav control used by App.tsx's top row (group tabs,
 * sub-tabs, period and category filters) and the floating profile/about
 * stack bottom-left.
 *
 * Pure presentational. Styling lives in NavBtn.module.css; this file only
 * decides which classes apply. `dot` paints the layer's own colour in a
 * 6px marker — the only place a category colour appears in the chrome.
 * `index` staggers an entrance animation when buttons mount as a row.
 */
import React from "react";
import { cn } from "../utils/cn.ts";
import s from "./NavBtn.module.css";

export function NavBtn({ onClick, title, active, dot, icon, children, style, index, ariaLabel }: {
  onClick: () => void; title?: string; active?: boolean; dot?: string;
  icon?: boolean; children: React.ReactNode; style?: React.CSSProperties;
  index?: number; ariaLabel?: string;
}) {
  return (
    <button
      onClick={onClick}
      title={title}
      aria-label={ariaLabel}
      aria-pressed={active}
      className={cn(s.btn, active && s.btnOn, icon && s.btnIcon)}
      style={{
        animation: index != null ? `navBtnIn 0.25s cubic-bezier(0.16, 1, 0.3, 1) ${index * 40}ms both` : undefined,
        ...style,
      }}
    >
      {dot && !active && <span className={s.dot} aria-hidden="true" style={{ "--nav-dot": dot } as React.CSSProperties} />}
      {children}
    </button>
  );
}
